import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/header-logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-ff616210"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header__logo-image-block" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "header__logo-image",
  src: _imports_0
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "0.5",
  y: "0.5",
  width: "34",
  height: "33",
  rx: "7.5",
  fill: "#1B1A1A"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M26 13L20 7.74001C19.45 7.24805 18.7379 6.97607 18 6.97607C17.262 6.97607 16.55 7.24805 16 7.74001L9.99997 13C9.68234 13.2841 9.42887 13.6326 9.25644 14.0223C9.08402 14.4119 8.99659 14.8339 8.99997 15.26V24C8.99997 24.7957 9.31604 25.5587 9.87865 26.1213C10.4413 26.6839 11.2043 27 12 27H24C24.7956 27 25.5587 26.6839 26.1213 26.1213C26.6839 25.5587 27 24.7957 27 24V15.25C27.0019 14.8256 26.9138 14.4055 26.7414 14.0177C26.5691 13.6298 26.3163 13.283 26 13ZM20 25H16V20C16 19.7348 16.1053 19.4804 16.2929 19.2929C16.4804 19.1054 16.7348 19 17 19H19C19.2652 19 19.5195 19.1054 19.7071 19.2929C19.8946 19.4804 20 19.7348 20 20V25ZM25 24C25 24.2652 24.8946 24.5196 24.7071 24.7071C24.5195 24.8946 24.2652 25 24 25H22V20C22 19.2044 21.6839 18.4413 21.1213 17.8787C20.5587 17.3161 19.7956 17 19 17H17C16.2043 17 15.4413 17.3161 14.8787 17.8787C14.316 18.4413 14 19.2044 14 20V25H12C11.7348 25 11.4804 24.8946 11.2929 24.7071C11.1053 24.5196 11 24.2652 11 24V15.25C11.0002 15.108 11.0306 14.9677 11.0892 14.8384C11.1478 14.7091 11.2333 14.5937 11.34 14.5L17.34 9.25001C17.5225 9.08969 17.7571 9.00127 18 9.00127C18.2429 9.00127 18.4775 9.08969 18.66 9.25001L24.66 14.5C24.7666 14.5937 24.8521 14.7091 24.9108 14.8384C24.9694 14.9677 24.9998 15.108 25 15.25V24Z",
  fill: "#1860CC"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "0.5",
  y: "0.5",
  width: "34",
  height: "33",
  rx: "7.5",
  stroke: "#252D30"
}, null, -1))
const _hoisted_6 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header__clear" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.mainClasses)
  }, [
    _createElementVNode("div", {
      class: "header__menu",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.startPage()))
    }, "В меню"),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      (_openBlock(), _createElementBlock("svg", {
        class: "header__logo-home",
        width: "35",
        height: "34",
        viewBox: "0 0 35 34",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.startPage()))
      }, _hoisted_6))
    ]),
    _hoisted_7
  ], 2))
}